import { IconType } from "@src/appV2/redesign/components/Icon.types";
import { useWorkplaceMenuPrivilegesProviderContext } from "../Navigation/privilegesProviders/WorkplaceMenuPrivilegesProvider";
import { useHistory } from "react-router-dom";
import { getLocation } from "@src/appV2/redesign/utils/routes";
import { useHelpCenterEntry } from "@src/appV2/HelpCenter/useHelpCenterEntry";

export function useNavHeader(): {
  displayHelpButton: boolean;
  onClickHelpButton: () => void;

  displaySettingsButton: boolean;
  iconTypeSettingsButton: IconType;
  onClickSettingsButton: () => void;
} {
  const workplaceMenuPrivileges = useWorkplaceMenuPrivilegesProviderContext();
  const history = useHistory();

  const displayHelpButton = workplaceMenuPrivileges.helpCenter ?? false;
  const helpCenterEntry = useHelpCenterEntry();
  function onClickHelpButton() {
    if (helpCenterEntry.kind === "action") {
      helpCenterEntry.onClick();
      return;
    }
    history.push(helpCenterEntry.routeTo);
  }

  const displaySettingsButton = workplaceMenuPrivileges.managementSection?.settings ?? false;
  const iconTypeSettingsButton = "cogwheel";
  function onClickSettingsButton() {
    history.push(getLocation("settings"));
  }

  return {
    displayHelpButton,
    onClickHelpButton,

    displaySettingsButton,
    iconTypeSettingsButton,
    onClickSettingsButton,
  };
}
